//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;


    // play button listener (if they click the video)
    document.querySelectorAll(".productVisualBtn")?.forEach(function (element) {
        element.addEventListener("click", function () {

            // hide play button
            this.querySelector(".productVisualBtnPlay").classList.add("active");

            //pause all other videos if they're playing and show their play button
            document.querySelectorAll(".productVisualBtn").forEach(function (other_video) {
                if ((other_video !== element) && (!other_video.querySelector(".productVisualBtnVid").paused)) {
                    other_video.querySelector(".productVisualBtnVid").pause();
                    other_video.querySelector(".productVisualBtnPlay").classList.remove("active");
                }
            });

            // if this video is paused, play it, otherwise pause it (toggles play/pause)
            if (this.querySelector(".productVisualBtnVid").paused) {
                this.querySelector(".productVisualBtnVid").play();
                this.querySelector(".productVisualBtnPlay").classList.add("active");
            } else {
                this.querySelector(".productVisualBtnVid").pause();
                this.querySelector(".productVisualBtnPlay").classList.remove("active");
            }

        });
    });

    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })


    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;

            let priceHTML = price(activeVariant.price, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                priceHTML = `<s>${price(activeVariant.compare_at_price, true)}</s> ${price(activeVariant.price, true)}`;
            }

            section.querySelector(".productATC").innerHTML = `ADD TO CART ${priceHTML}`;
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    // listen for E-Gift toggle
    if (product.handle === "gift-card") {
        section.querySelector('.productGiftFormControlsSwitchInput').addEventListener('change', function () {
            // if checked, show form
            if (this.checked) {
                section.querySelector('.productGiftFormWrap').classList.add('active');
                section.querySelector('.productGiftFormControlsTitle.default').classList.remove('active');
                section.querySelector('.productGiftFormControlsTitle.gift').classList.add('active');

            } else {
                section.querySelector('.productGiftFormWrap').classList.remove('active');
                section.querySelector('.productGiftFormControlsTitle.default').classList.add('active');
                section.querySelector('.productGiftFormControlsTitle.gift').classList.remove('active');
            }

        });

        // listen for E-gift button
        section.querySelector('.productGiftFormControlsLeft').addEventListener('click', function () {
            // click toggle button
            section.querySelector('.productGiftFormControlsSwitchInput').click()
        });


        // setup flat pickr
        document.addEventListener("DOMContentLoaded", async function () {
            let today = new Date();
            flatpickr(document.querySelector('.giftInput.date'), {
                dateFormat: "m/d/Y",
                minDate: today,
                disableMobile: "true"
            });
        });

        // for each gift input, add event listener to update gift inputs
        section.querySelectorAll('.giftInput').forEach(input => {
            input.addEventListener('input', updateGiftInputs);
        });

        // on load, update gift inputs
        updateGiftInputs();


        function updateGiftInputs() {
            // for each gift input, add active class if value isn't blank
            section.querySelectorAll('.giftInput').forEach(input => {
                let label = input.closest('.productGiftFormItem')?.querySelector('.productGiftFormItemLabel');

                if (input.value) {
                    label?.classList.add('active');
                } else {
                    label?.classList.remove('active');
                }

            });
        }
    }


    /**************
     Product ATC
     ***************/
    section.querySelector('.productATC').addEventListener("click", async function () {


        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productSellingLabelInput.sub')?.checked) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingLabelBodyBottomWrapContentLabelInput:checked').value)
        }

        // Gift card logic
        if (product.handle === "gift-card") {
            // check if required fields empty for E-Gift
            let errors = [];
            if (section.querySelector('.productGiftFormControlsSwitchInput').checked) {
                section.querySelectorAll('.giftInput').forEach(input => {
                    if (input.required && !input.value) {
                        errors.push(input.ariaLabel);
                    }
                });
            }

            // if errors, show alert and return
            if (errors.length > 0) {
                alert(`Please fill out the following fields: ${errors.join(', ')}`);
                return;
            }

            // Check for valid Email
            let email = section.querySelector('.giftInput.email').value;
            let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            let validEmail = emailRegex.test(email);

            if (!validEmail && section.querySelector('.productGiftFormControlsSwitchInput').checked) {
                alert("Please use a valid email.");
                return;
            }

            // add gift card to formData
            if (section.querySelector('.productGiftFormControlsSwitchInput').checked) {
                // convert MM-DD-YYYY to YYYY-MM-DD
                const date = new Date(section.querySelector('.giftInput.date').value);
                const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
                // add gift card properties
                formData.items[0].properties = {
                    "Recipient name": section.querySelector(".productGiftFormItemName").value,
                    "Recipient email": section.querySelector(".productGiftFormItemEmail").value,
                    "Message": section.querySelector(".productGiftFormItemTextarea").value,
                    "Send on": formattedDate,
                    "__shopify_send_gift_card_to_recipient": true
                };
            }
        }

        // add loading animation
        this.classList.add("loading");

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });

    // setup Dropdowns
    section.querySelectorAll(".productInfoDropTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    document.addEventListener("DOMContentLoaded", async function () {

        // show on scroll
        let isVisible = false;
        const productFormATC = document.querySelector(".productATC");

        // listen if the original ATC button is scrolled off screen
        window.addEventListener('scroll', function () {
            const scrollTop = window.scrollY;
            const buttonOffsetTop = productFormATC.offsetTop;

            if (scrollTop > buttonOffsetTop && !isVisible) {
                document.querySelector('.sticky').classList.add('active');
                isVisible = true;
            } else if (scrollTop <= buttonOffsetTop && isVisible) {
                document.querySelector('.sticky').classList.remove('active');
                isVisible = false;
            }
        })


        // listen for click
        document.querySelector('.stickyLink').addEventListener('click', function (e) {
            e.preventDefault();

            this.classList.add('loading');

            // add to cart
            document.querySelector('.productATC').click();

            // wait 1 s before removing loading class
            setTimeout(() => {
                this.classList.remove('loading');
            }, 1000);


        })
    })


});
